export const name = 're-core-page-user-login'
export const component = 're-login'

import {factory} from '../../../../lib/page'

const props = {
  email: {},
}
export default factory(name, {props, component})
